import { render, staticRenderFns } from "./ReadOnlyTextField.vue?vue&type=template&id=303bf7d0"
import script from "./ReadOnlyTextField.vue?vue&type=script&lang=js"
export * from "./ReadOnlyTextField.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyTextField.vue?vue&type=style&index=0&id=303bf7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
